import React, { useState, useEffect } from "react";
import axios from "axios";
import { Monitor01, Phone01, Spinner, Tabs } from "@opendate-app/setlist";

import { toastError } from "../../../shared/toastHelper";
import { flattenLiquidData } from "../../../shared/liquidUtils";
import TemplateHTMLPreview from "../BeefreeTemplates/TemplateHTMLPreview";

const containerStyle = {
  display: "flex",
  width: "100%",
  background: "var(--sl-bg-primary)",
  boxShadow: "var(--sl-shadow-sm)",
  color: "var(--sl-text-primary)",
  fontSize: 14,
};

const sampleDataStyle = {
  display: "flex",
  flexDirection: "column",
  gap: 8,
  flexShrink: 0,
  padding: 16,
  width: "33%",
  fontSize: 12,
};

const sampleDataHeaderStyle = {
  borderBottom: "1px solid var(--sl-border-secondary)",
  color: "var(--sl-text-tertiary)",
  fontSize: 10,
  paddingBottom: 4,
};

const truncateStyle = {
  overflow: "hidden",
  textOverflow: "ellipsis",
  whiteSpace: "nowrap",
};

const previewColumnStyle = {
  display: "flex",
  flexDirection: "column",
  flexGrow: 1,
  minWidth: 0,
  borderLeft: "1px solid var(--sl-border-secondary)",
};

const toolbarStyle = {
  display: "flex",
  borderBottom: "1px solid var(--sl-border-secondary)",
  padding: 8,
};

const previewFrameStyle = { border: "none", height: "100%", width: "100%", overflow: "auto" };

const mobileStageStyle = {
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  background: "var(--sl-bg-tertiary)",
  padding: 8,
  height: "60vh",
};

const mobileFrameStyle = {
  background: "var(--sl-bg-primary)",
  height: "100%",
  maxHeight: "60vh",
  overflow: "auto",
  width: 320,
};

export default ({
  template,
  sampleData,
  beefreeTemplateId,
  csrfToken,
}) => {
  const [isLoading, setIsLoading] = useState(true);
  const [htmlContent, setHtmlContent] = useState("");
  const [viewer, setViewer] = useState("desktop");

  const flattenedSampleData = flattenLiquidData(sampleData);

  useEffect(() => {
    axios.defaults.headers.common["X-CSRF-TOKEN"] = csrfToken;
    axios.post(`/admin/beefree_templates/${beefreeTemplateId}/render_liquid_html`, {
      beefree_template: {
        template: template,
        sample_data: sampleData,
      },
    })
      .then(({ data }) => {
        setHtmlContent(data.parsedText);
        setIsLoading(false);
      })
      .catch(() => toastError("Could not fetch email preview, please try again"));
  }, [template, beefreeTemplateId, csrfToken, sampleData]);

  if (isLoading) {
    return (
      <div style={{ display: "flex", justifyContent: "center", alignItems: "center", height: "50vh" }}>
        <Spinner aria-label="Loading preview" />
      </div>
    );
  }

  return (
    <div style={containerStyle}>
      {flattenedSampleData.length ? (
        <div style={sampleDataStyle}>
          <div style={sampleDataHeaderStyle}>SAMPLE DATA ATTRIBUTES</div>
          {flattenedSampleData.map(({ path, value }) => (
            !!value ? (
              <div key={path} style={truncateStyle}>
                <div style={{ color: "var(--sl-text-quaternary)" }}>{path}</div>
                <div style={{ color: "var(--sl-text-brand)" }}>{`"${value}"`}</div>
              </div>
            ) : null
          ))}
        </div>
      ) : null}
      <div style={previewColumnStyle}>
        <div style={toolbarStyle}>
          <Tabs
            variant="button-border"
            size="sm"
            items={[
              { value: "desktop", label: "Desktop", icon: Monitor01 },
              { value: "mobile", label: "Mobile", icon: Phone01 },
            ]}
            value={viewer}
            onChange={setViewer}
            collapseBelow={0}
          />
        </div>
        {viewer === "desktop" ? (
          <div style={{ height: "60vh", overflow: "auto", padding: 4 }}>
            <TemplateHTMLPreview htmlContent={htmlContent} style={previewFrameStyle} />
          </div>
        ) : (
          <div style={mobileStageStyle}>
            <div style={mobileFrameStyle}>
              <TemplateHTMLPreview htmlContent={htmlContent} style={previewFrameStyle} />
            </div>
          </div>
        )}
      </div>
    </div>
  );
};
